/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import "./InstallPrompt.css";

import { useEffect, useState } from "react";
import { Logo } from "assets/customAssets";
import CustomButton from "components/CustomButton/CustomButton";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import { DONT_ALLOW_INSTALL_PROMPT, LAST_INSTALL_PROMPT_TIMESTAMP } from "types/global";


interface InstallPromtProps extends React.HTMLProps<HTMLDivElement> {
	// container: Element | DocumentFragment;
}
export const InstallPrompt = (props: InstallPromtProps) => {
	const [animation, setAnimation] = useState("stop");
	const [installPrompt, setInstallPrompt] = useState<any>();

	useEffect(() => {
		window.addEventListener("beforeinstallprompt", (ev: any) => {
			ev.preventDefault();

			setInstallPrompt(ev);

			if (window.CONFIG.REACT_APP_INSTALL_PWA.DISABLE_DEFAULT_PROMPT) return;

			const allowed = localStorage.getItem(DONT_ALLOW_INSTALL_PROMPT);
			if (allowed !== null) return;

			const lastRequest = localStorage.getItem(LAST_INSTALL_PROMPT_TIMESTAMP);
			let askable = true;
			if (lastRequest !== undefined && lastRequest !== null) {
				const lastTime = parseInt(lastRequest);
				const now = new Date().getTime();
				if (Math.abs(now - lastTime) < window.CONFIG.REACT_APP_INSTALL_PWA.REITERATE_INSTALL_PROMPT_INTERVAL) askable = false;
			}
			if (askable) {
				setAnimation("appear");
			}
		});
	}, []);

	const handleAnimationEnd = (ev: any) => {
		if (ev.animationName.includes("appear")) setAnimation("idle");
		if (ev.animationName.includes("idle")) setAnimation("disappear");
		if (ev.animationName.includes("disappear")) setAnimation("stop");
	};

	const handleClick = () => {
		if (animation === "idle") setAnimation("disappear");
	};

	const handleInstallPrompt = (value: boolean | undefined) => {
		if (value === true && installPrompt !== undefined) {
			localStorage.removeItem(DONT_ALLOW_INSTALL_PROMPT);
			localStorage.removeItem(LAST_INSTALL_PROMPT_TIMESTAMP);
			installPrompt.prompt();
		} else if (value === undefined) {
			localStorage.removeItem(DONT_ALLOW_INSTALL_PROMPT);
			const now = new Date().getTime();
			localStorage.setItem(LAST_INSTALL_PROMPT_TIMESTAMP, now.toString());
		} else if (value === false) {
			localStorage.setItem(DONT_ALLOW_INSTALL_PROMPT, "true");
			localStorage.removeItem(LAST_INSTALL_PROMPT_TIMESTAMP);
		}
		if (animation === "idle") setAnimation("disappear");
	};

	return (
		// eslint-disable-next-line jsx-a11y/no-static-element-interactions
		<div className={`install-prompt ${animation}`} onAnimationEnd={handleAnimationEnd} onClick={handleClick} aria-hidden={animation !== "idle"}>
			<img className="install-prompt-logo" src={Logo} alt="company-logo"></img>
			<div className="text">
				Puoi installare HSB per un'esperienza di utilizzo migliore, clicca su "installa" e accetta la richiesta del browser. Troverai maggiori
				informazioni nella pagina help
			</div>

			<CustomButton
				className="button"
				buttonType={CustomButtonType.positive}
				text={"Installa"}
				OnClick={() => {
					handleInstallPrompt(true);
				}}
			/>
			<CustomButton
				className="button"
				buttonType={CustomButtonType.positive}
				text={"Più tardi"}
				OnClick={() => {
					handleInstallPrompt(undefined);
				}}
			/>
			<p
				className="not-again"
				onClick={() => {
					handleInstallPrompt(false);
				}}
			>
				Non chiedermelo più
			</p>
		</div>
	);
};
